const routeConfig = [
	{ path: '/login', name: 'Login', component: 'appLogin', useAsDefault: true },
	{ path: '/logout', name: 'Logout', component: 'appLogout' },
	{ path: '/...', name:'Daisy',  component: 'appDaisy' },
	{ path: '/**', redirectTo: ['Daisy']  }
];

export default routeConfig;
